import React from 'react';
import { Platform, StyleSheet, Text, TouchableOpacity } from 'react-native';
import { DNABox, DNAText, luxColors, Popover, } from '@alucio/lux-ui';
import VirtualModal from '../../VirtualModal/VirtualModal';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import { useMeetingControls } from '../../../../src/hooks/useMeetingControls/useMeetingControl';
const styles = StyleSheet.create({
    backdrop: {
        backgroundColor: luxColors.modalBackdrop.primary,
    },
    internationalNumberText: {
        color: luxColors.info.primary,
        fontSize: 15,
    },
    infoIcon: {
        color: colors['color-text-basic'],
        height: 20,
        width: 20,
    },
    infoText: {
        color: luxColors.info.primary,
    },
    infoLabel: {
        color: luxColors.info.primary,
        opacity: 0.48,
        marginTop: 22,
    },
    copyLink: {
        color: luxColors.primary.primary,
        marginLeft: 16,
    },
    modalContentText: {
        color: luxColors.info.primary,
        fontSize: 15,
        lineHeight: 48,
        opacity: 0.5,
    },
    tinyMarginTop: {
        marginTop: 4,
    },
    dialNumber: {
        color: luxColors.info.primary,
        fontSize: 24,
        fontWeight: 'bold',
        lineHeight: 32,
        marginBottom: 5,
    },
});
export const MeetingInfoDialog = (props) => {
    const { attendeeCount, hostName, maxAttendees, meetingURL } = useMeetingControls();
    const copyLink = () => {
        if (Platform.OS === 'web') {
            navigator.clipboard.writeText(meetingURL)
                .catch(err => {
                console.error('Could not copy text: ', err); // [TODO] - Error handle when permissions are denied
            });
        }
    };
    return (React.createElement(Popover, { lazyMount: true, interactive: true, offset: 10, placement: "bottom-start", type: "menu", visible: true, onBackdropPress: props.onClose },
        React.createElement(Popover.Anchor, null,
            React.createElement(TouchableOpacity, null)),
        React.createElement(Popover.Content, null,
            React.createElement(VirtualModal, { width: 500, headerText: `${hostName}'s Room`, onClose: props.onClose },
                React.createElement(DNABox, { appearance: "col", alignX: "start", alignY: "start" },
                    React.createElement(Text, { style: styles.modalContentText }, "Host"),
                    React.createElement(Text, { style: styles.infoText }, hostName),
                    React.createElement(Text, { style: styles.modalContentText }, "Invite Link"),
                    React.createElement(DNABox, { appearance: "row" },
                        React.createElement(DNAText, { style: styles.infoText }, meetingURL),
                        React.createElement(TouchableOpacity, { onPress: copyLink },
                            React.createElement(DNAText, { style: styles.copyLink }, "Copy Meeting Link"))),
                    React.createElement(Text, { style: styles.modalContentText }, "Room Capacity"),
                    React.createElement(DNAText, { style: styles.infoText },
                        attendeeCount,
                        " of ",
                        maxAttendees,
                        " participants"))))));
};
//# sourceMappingURL=DialogMenu.js.map